/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { Basil } from './basil';

const DEFAULT_CONFIG = {
  name: 'storage-module',
};

@injectable()
export class StorageModule {
  name = DEFAULT_CONFIG?.name;
  private static instance: StorageModule;
  private basil: any;
  static displayName = 'StorageModule';
  constructor() {
    this.basil = new Basil({});
    this.report();
  }

  async init() {}

  set(
    key: string,
    value: any,
    storage: 'local' | 'cookie' | 'session' | 'memory' = 'local'
  ) {
    return this.basil.set(key, value, { storages: storage });
  }

  get(
    key: string,
    storage: 'local' | 'cookie' | 'session' | 'memory' = 'local'
  ) {
    return this.basil.get(key, { storages: storage });
  }

  remove(
    key: string,
    storage: 'local' | 'cookie' | 'session' | 'memory' = 'local'
  ) {
    return this.basil.remove(key, { storages: storage });
  }

  check(storage: 'local' | 'cookie' | 'session' | 'memory') {
    return this.basil.check(storage);
  }

  reset(storage: 'local' | 'cookie' | 'session' | 'memory' = 'local') {
    return this.basil.reset({ storages: storage });
  }

  keys(storage: 'local' | 'cookie' | 'session' | 'memory' = 'local') {
    return this.basil.keys({ storages: storage });
  }

  //@ts-ignore
  private convertStorageToId(
    storage: 'local' | 'cookie' | 'session' | 'memory'
  ) {
    let _storage: any = storage;
    switch (storage) {
      case 'local':
        _storage = 'localStorage';
        break;
      case 'cookie':
        _storage = 'cookie';
        break;
      case 'memory':
        _storage = 'memory';
        break;
      case 'session':
        _storage = 'sessionStorage';
        break;
    }
    return _storage;
  }

  private report() {
    console.log(this.name, `⚡⚡⚡===================⚡⚡⚡`);
    console.log(this.name, 'Module Report');
    console.log(this.name, '⦿ Name: ' + this.name);
    console.log(this.name, `⚡⚡⚡===================⚡⚡⚡`);
  }
}
